export enum BFXAppNotificationSubType {
  //Fill subtypes
  FILL_FULL,
  FILL_PART,
}
